import { render } from "./RatingEditorCmp.vue?vue&type=template&id=36b36dac"
import script from "./RatingEditorCmp.vue?vue&type=script&lang=js"
export * from "./RatingEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__